import request from '@/utils/request'

// （DLN側）作業予定一覧（発注詳細単位) 検索
export function queryBuildingSameDayCheckableList(data) {
  return request({
    url: `/api/purchaseOrderDetailRc/queryOrderDetailList`,
    method: 'post',
    data,
  })
}

// (DLN側)作業予定一覧（作業日単位) 条件・コメント
export function getWeeklyCondition(data) {
  return request({
    url: `/api/workingPlanAndResultRc/getWeeklyCondition`,
    method: 'post',
    data,
  })
}

// 作業日詳細（日程追加） 発注詳細
export function purchaseOrderDetailRc(data) {
  return request({
    url: `/api/purchaseOrderDetailRc/detail/${data}`,
    method: 'get',
    data,
  })
}

// 作業日詳細（日程追加） 発注詳細
export function workPlanDateList(data) {
  return request({
    url: `/api/purchaseOrderDetailRc/workPlanDateList/${data}`,
    method: 'get',
    data,
  })
}

// 作業日程変更 検索
export function getworkScheduleChange(data) {
  return request({
    url: `/api/workingPlanAndResultRc/edit/${data}`,
    method: 'get',
  })
}

// 作業日詳細（日程追加） 作業日追加/更新
export function workPlanDateUpdate(data) {
  return request({
    url: `/api/purchaseOrderDetailRc/workPlanDateUpdate`,
    method: 'post',
    data,
  })
}

// 作業日程調整履歴
export function workingPlanAndResultRcHistory(data) {
  return request({
    url: `/api/workingPlanAndResultRcHistory/${data}/list`,
    method: 'post',
    data,
  })
}

// (DLN側)作業予定一覧（作業日単位) 未入力一括プッシュ
export function notInputPush(data) {
  return request({
    url: `/api/workingPlanAndResultRc/notInputPush`,
    method: 'post',
    data,
  })
}

// (DLN側)作業予定一覧（作業日単位) 「登録」ボタンをクリック時
export function savaAll(data) {
  return request({
    url: `/api/workingPlanAndResultRc/savaAll`,
    method: 'post',
    data,
  })
}

// (DLN側)作業予定一覧（作業日単位) 不可日リストDL
export function notAllowDateExcelOutput(data) {
  return request({
    url: `/api/workingPlanAndResultRc/notAllowDateExcelOutput`,
    method: 'post',
    data,
  })
}

// (DLN側)作業予定一覧（作業日単位) 不可日プッシュ
export function notAllowDatePush(data) {
  return request({
    url: `/api/workingPlanAndResultRc/notAllowDatePush`,
    method: 'post',
    data,
  })
}
